var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 37,
    viewBox: "0 0 45 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6429 13.6993C40.6429 9.88236 37.5092 6.75769 33.6766 6.75769H22.9876C22.0087 6.75769 20.4263 7.85918 20.4263 9.30991V27.3098C20.5652 28.8721 22.0232 29.8744 23 29.8744H33.6745C37.505 29.8744 40.6408 26.7518 40.6408 22.9328C40.6408 21.1638 39.9668 19.5457 38.8635 18.3161C39.9668 17.0864 40.6408 15.4683 40.6408 13.6993H40.6429Z",
    fill: "url(#paint0_linear_885_936)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_885_936",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 6,
    width: 21,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6429 13.6993C40.6429 9.88236 37.5092 6.75769 33.6766 6.75769H22.9876C21.8552 6.75769 20.4263 7.94184 20.4263 9.52484V27.3098C20.6917 29.2751 22.1912 29.8744 23.168 29.8744H33.6745C37.505 29.8744 40.6408 26.7518 40.6408 22.9328C40.6408 21.1638 39.9668 19.5457 38.8635 18.3161C39.9668 17.0864 40.6408 15.4683 40.6408 13.6993H40.6429Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_885_936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1442 9.26855H19.5239C18.8573 9.26855 18.3169 9.80704 18.3169 10.4713V10.9941C18.3169 11.6584 18.8573 12.1969 19.5239 12.1969H42.1442C42.8108 12.1969 43.3512 11.6584 43.3512 10.9941V10.4713C43.3512 9.80704 42.8108 9.26855 42.1442 9.26855Z",
    fill: "#0063BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8367 21.5543H23.7361C23.3307 21.5543 23.002 21.8819 23.002 22.2859V22.6021C23.002 23.0061 23.3307 23.3336 23.7361 23.3336H37.8367C38.2422 23.3336 38.5709 23.0061 38.5709 22.6021V22.2859C38.5709 21.8819 38.2422 21.5543 37.8367 21.5543Z",
    fill: "#0063BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0369 24.8588H32.094C31.6886 24.8588 31.3599 25.1863 31.3599 25.5903V25.9065C31.3599 26.3106 31.6886 26.6381 32.094 26.6381H35.0369C35.4424 26.6381 35.7711 26.3106 35.7711 25.9065V25.5903C35.7711 25.1863 35.4424 24.8588 35.0369 24.8588Z",
    fill: "#0063BC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1571 10.3019H8.79151C8.24974 10.3019 7.81055 10.7395 7.81055 11.2794V15.6295C7.81055 16.1694 8.24974 16.607 8.79151 16.607H13.1571C13.6989 16.607 14.1381 16.1694 14.1381 15.6295V11.2794C14.1381 10.7395 13.6989 10.3019 13.1571 10.3019Z",
    fill: "#02AFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0028 20.8972H10.6372C10.0954 20.8972 9.65625 21.3349 9.65625 21.8747V26.2249C9.65625 26.7647 10.0954 27.2023 10.6372 27.2023H15.0028C15.5446 27.2023 15.9838 26.7647 15.9838 26.2249V21.8747C15.9838 21.3349 15.5446 20.8972 15.0028 20.8972Z",
    fill: "#02AFEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72931 17.5493H4.54998C4.1594 17.5493 3.84277 17.8648 3.84277 18.254V21.4221C3.84277 21.8113 4.1594 22.1268 4.54998 22.1268H7.72931C8.11989 22.1268 8.43651 21.8113 8.43651 21.4221V18.254C8.43651 17.8648 8.11989 17.5493 7.72931 17.5493Z",
    fill: "#02AFEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96667 13.7861H4.32412C4.01486 13.7861 3.76416 14.0359 3.76416 14.3441V15.9808C3.76416 16.289 4.01486 16.5388 4.32412 16.5388H5.96667C6.27592 16.5388 6.52663 16.289 6.52663 15.9808V14.3441C6.52663 14.0359 6.27592 13.7861 5.96667 13.7861Z",
    fill: "#02AFEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20251 15.9209H0.559959C0.250702 15.9209 0 16.1707 0 16.4789V18.1156C0 18.4238 0.250702 18.6736 0.559959 18.6736H2.20251C2.51176 18.6736 2.76247 18.4238 2.76247 18.1156V16.4789C2.76247 16.1707 2.51176 15.9209 2.20251 15.9209Z",
    fill: "#02AFEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72985 23.0796H5.07071C4.76603 23.0796 4.51904 23.3257 4.51904 23.6293V25.2826C4.51904 25.5862 4.76603 25.8323 5.07071 25.8323H6.72985C7.03452 25.8323 7.28151 25.5862 7.28151 25.2826V23.6293C7.28151 23.3257 7.03452 23.0796 6.72985 23.0796Z",
    fill: "#02AFEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1182 9.2583H12.9436C14.1589 9.2583 15.1461 10.2441 15.1461 11.453V15.3795C15.1461 16.5905 14.1568 17.5742 12.9436 17.5742H11.6619C11.6619 17.5742 11.6557 17.5742 11.6515 17.5742H10.4777C10.1707 17.5742 9.92188 17.8222 9.92188 18.1281V19.2977C9.92188 19.6036 10.1707 19.8516 10.4777 19.8516H11.6474L14.7894 19.8536C16.0047 19.8536 16.9919 20.8394 16.9919 22.0484V25.9748C16.9919 27.1859 16.0026 28.1696 14.7894 28.1696H12.506C12.3173 28.1964 12.17 28.3576 12.17 28.5539C12.17 28.6221 12.1887 28.6841 12.2177 28.7379L12.2965 28.8391C12.8088 29.4591 13.5824 29.8559 14.4472 29.8559H25.0159C31.0158 29.8559 35.9247 24.9643 35.9247 18.9857V17.6114C35.9247 11.6328 31.0158 6.74121 25.0159 6.74121H14.4472C13.207 6.74121 12.1513 7.56164 11.7946 8.68379L11.7511 8.83879C11.7511 8.83879 11.749 8.85532 11.749 8.86359C11.749 9.07024 11.9128 9.2397 12.1182 9.2521",
    fill: "url(#paint1_linear_885_936)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_885_936",
    x1: 20.4283,
    y1: 18.3161,
    x2: 40.6429,
    y2: 18.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#002857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_885_936",
    x1: 9.92395,
    y1: 18.3037,
    x2: 35.9247,
    y2: 18.3037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#02AFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#01A5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#008ACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClosed);
export default __webpack_public_path__ + "static/media/logo-closed.91568624452ad60131cf414b3087b828.svg";
export { ForwardRef as ReactComponent };